import React, { Component } from "react";
import {
	Box,
	InputLabel,
	GridList,
	ListItem,
	ListItemIcon,
	ListItemText,
	TextField,
	Fab,
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Divider,
	TablePagination,
	Tabs,
	Tab,
	Typography
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search"
import {
	_DefaultIconSize,
	_DefaultIconColor,
	guessIconset,
	getAllIcons,
	isIonicons
} from "./Iconset.js";
import Icon from "./Icon.js";
import style from "./style.js";
import _ from "lodash"
/**
 * Render an iconPicker component
 *
 * <IconPicker iconset={iconset} size={size} onSelect={callback(item)} />
 * iconset  = string (check availableIconsets constant)
 * size     = integer (default 60)
 * label    = string
 * onSelect = callback function that accept one string parameter (the icon name)
 */
class IconPicker extends Component {
	constructor(props) {
		super(props);
		this.iconsPerPage=100
		let iconSwitch = this.switchIconSet(this.props.icon, this.props.iconset, true)
		this.state = {
			open: false,
			search: "",
			iconset: iconSwitch.iconset,
			tabIndex:0,
			iconSelected: iconSwitch.icon,
			countPages:1,
			page:0
		};
		this.onChangeTab=this.onChangeTab.bind(this)
		this.onChangePage=this.onChangePage.bind(this)
		this.filterIcons=this.filterIcons.bind(this)
		this.size = this.props.size || _DefaultIconSize;
		this.color = this.props.color || _DefaultIconColor;
		this.callback = this.props.onSelect
			? this.props.onSelect
			: icon => {
					console.log("default onSelect", icon);
			  };
		this.buttonLabel = this.props.label || "IconPicker";
		this.buttonStyle = this.props.buttonStyle || {};
		this.iconStyle = this.props.iconStyle || {};
		// fix ionic size
		if (isIonicons(this.state.iconset)) {
			this.size = this.size + "px";
		}
	}
	
	componentWillReceiveProps(nextProps){
		if(this.props.icon!=nextProps.icon||this.props.iconset!=nextProps.iconset){
			let iconSwitch = this.switchIconSet(nextProps.icon, nextProps.iconset, true) 
			console.log("ICONSET", iconSwitch)

			this.setState({iconSelected:iconSwitch.icon, iconset:iconSwitch.iconset})
		}
	}

	switchIconSet(icon, iconset, toRender){
		console.log("ICON", icon)
		if(icon){
			if(toRender){
				switch(iconset){
					case "MaterialIcons": return {iconset:"material", icon:"ic_"+icon.replace(/-/g,"_")}
					case "FontAwesome": return {iconset:"fa", icon: _.camelCase(icon)}
					case "Ionicons": return {iconset:"ionicons3", icon:icon}
					default: return {iconset:"material", icon:"ic_"+icon.replace(/-/g,"_")}
				}
			}else{
				switch(iconset){
					case "material": return {iconset:"MaterialIcons", icon:icon.substring(3, icon.length).replace(/_/g,"-")}
					case "fa": return {iconset:"FontAwesome", icon: _.kebabCase(icon)}
					case "ionicons3": return {iconset:"Ionicons", icon:icon}
					default: return {iconset:"MaterialIcons", icon:icon.substring(3, icon.length).replace(/_/g,"-")}
				}
			}
		}else{
			return toRender?{iconset:"material", icon:""}:{iconset:"MaterialIcons", icon:""}
		}
	}



	/*
   * Modal Dialog Methods
   */

	onOpen = () => {
		this.setState({ open: true });
	};

	onClose = () => {
		this.setState({ open: false });
	};

	onClick = icon => {
		this.setState({ search: "", open: false, iconSelected:icon });
		let iconSwitch = this.switchIconSet(icon, this.state.iconset, false)
		console.log("ON CLICK ICON", iconSwitch)
		this.callback({icon:iconSwitch.icon, family:iconSwitch.iconset});
	};

	/*
   * Filter Methods
   */

	onChangeSearchField = event => {
		let search = event.target.value,
			icons;
		this.setState({ search });
		if (this.state.iconset === "ionicons3") {
			icons = this.filterIcons(search);
		} else {
		}
		this.setState({ icons });
	};

	filterIcons = (search = "") => {
		let data = getAllIcons(this.state.iconset);
		let icons = this.state.iconset==="ionicons3"?data:Object.keys(data)
		if(search){
			let pattern = new RegExp(search);
			icons=icons.filter((value)=>{return pattern.test(value)})
		}
		let from = this.state.page*this.iconsPerPage
		let to = from + this.iconsPerPage
		let count = icons.length
		return {count:count, list:icons.slice(from,to)}
	};

	/*
   * Render Methods
   */

	// render an <Paper /> item with logo and logo name
	renderItem = icon => {
		let iconStyle = Object.assign({}, style.item, this.iconStyle, {
			color: this.color
		});
		let iconName = this.state.iconset == "material"?icon.substring(3, icon.length):icon
		return (
			<ListItem button
				key={icon}
				style={iconStyle}
				onClick={() => {
					this.onClick(icon);
				}}
			>
				<ListItemIcon>
					<Icon
						iconset={this.state.iconset}
						icon={icon}
						size={this.size}
						color={this.color}
					/>
				</ListItemIcon>
				<ListItemText primary={iconName} />
			</ListItem>
		);
	};

	renderIcons = () => {
		return this.filterIcons(this.state.search);
	};

	onChangeTab(evt, value){
		switch(value){
			case 1: this.setState({iconset:"fa", tabIndex:value, iconSelected:null, page:0}); break
			case 2: this.setState({iconset:"ionicons3", tabIndex:value, iconSelected:null, page:0}); break
			default: this.setState({iconset:"material", tabIndex:value, iconSelected:null, page:0	})
		}
	}

	onChangePage(evt, value){
		this.setState({page:value})
	}

	renderPages(icons){
		let tabs = []
		let count = (icons.count%this.iconsPerPage==0)?icons.count/this.iconsPerPage:Math.trunc(icons.count/this.iconsPerPage)+1
		for(let i = 0;i<count;i++){
			tabs.push(<Tab label={i+1} selected={this.state.page==i} style={{minWidth:0}}/>)
		}
		return tabs
	}
	// render dialog
	render() {
		// is it Ionic?
		let icons;
		// performance hack, only render icons when the popup is open
		if (this.state.open) {
			icons =  this.renderIcons()
		}
		return (
			<div className="columns-row-between">
				<div className="MuiInputBase-root MuiInput-root MuiInput-underline column-full" style={{height:32, width:"70%"}}>
					<Button
						onClick={this.onOpen}
						style={this.buttonStyle}
						color="primary"
					>
						{this.state.iconSelected?<Icon iconset={this.state.iconset} icon={this.state.iconSelected} size={24}/>
						:<Typography >Seleccionar</Typography>}
					</Button>
				</div>
				<Fab size="small"
					onClick={this.onOpen}
					color="primary"
				>
					<SearchIcon/>
				</Fab>
				
				<Dialog
					//modal={false}
					open={this.state.open}
					onClose={this.onClose}
					maxWidth
				>
					<DialogTitle>{this.buttonLabel}</DialogTitle>
					<DialogTitle>
						<InputLabel>Buscar</InputLabel>
						<TextField
							value={this.state.search}
							onChange={this.onChangeSearchField}
							fullWidth
						/>
						<Tabs indicatorColor="primary" value={this.state.tabIndex} onChange={this.onChangeTab} centered>
							<Tab label="Material" />
							<Tab label="FontAwesome"/>
							{/* <Tab label="Ionicons"/> */}
						</Tabs>
					</DialogTitle>
					<DialogContent >
						<GridList cols={6} cellHeight="auto">
							{icons&&icons.list.map(this.renderItem)}
						</GridList>
					</DialogContent>
					<DialogActions>
						<Typography>Página:</Typography>
						{icons&&
						<Tabs onChange={this.onChangePage} value={this.state.page} centered >
							{this.renderPages(icons)}
						</Tabs>
						}
						<Button variant="contained" color="primary" onClick={this.onClose}>Cerrar</Button>	
					</DialogActions>
				</Dialog>
			</div>
		);
	}
}

export default IconPicker;



// WEBPACK FOOTER //
// ./src/components/IconPicker/IconPicker.js